import { render } from "./App.vue?vue&type=template&id=09f218ef"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09f218ef&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__